import { render, staticRenderFns } from "./withdrawalSettings.vue?vue&type=template&id=836d4bcc&scoped=true&"
import script from "./withdrawalSettings.vue?vue&type=script&lang=js&"
export * from "./withdrawalSettings.vue?vue&type=script&lang=js&"
import style0 from "./withdrawalSettings.vue?vue&type=style&index=0&id=836d4bcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "836d4bcc",
  null
  
)

export default component.exports